import React from "react";

import SectionHeading from "../../Common/SectionHeading";

const ExploreArea = () => {
// ... existing code ...

const videoCategories = {
  HajjOrientation: [
    "https://www.youtube.com/embed/dWQKEnk6jV8",
    "https://www.youtube.com/embed/dWQKEnk6jV8",
  
  ],
  Mina: [
    "https://www.youtube.com/embed/dWQKEnk6jV8",
    "https://www.youtube.com/embed/dWQKEnk6jV8",
 
  ],
  LuxuryHotels: [
    "https://www.youtube.com/embed/dWQKEnk6jV8",
    "https://www.youtube.com/embed/dWQKEnk6jV8",

  ],
  Umrah: [
    "https://www.youtube.com/embed/dWQKEnk6jV8",
    "https://www.youtube.com/embed/dWQKEnk6jV8",
  ],
};

// ... rest of the code ...

  return (
    <>
      <section id="explore_area" className="section_padding_top">
        <div className="container">
          <SectionHeading heading="Explore Our Videos" />
          {/* Tab Navigation */}
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="theme_nav_tab">
                <nav className="theme_nav_tab_item">
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    {Object.keys(videoCategories).map((category, index) => (
                      <button
                        key={index}
                        className={`nav-link ${index === 0 ? "active" : ""}`}
                        id={`nav-${category.toLowerCase()}-tab`}
                        data-bs-toggle="tab"
                        data-bs-target={`#nav-${category.toLowerCase()}`}
                        type="button"
                        role="tab"
                        aria-controls={`nav-${category.toLowerCase()}`}
                        aria-selected={index === 0 ? "true" : "false"}
                      >
                        {category}
                      </button>
                    ))}
                  </div>
                </nav>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="tab-content" id="nav-tabContent">
                {Object.entries(videoCategories).map(([category, videos], index) => (
                  <div
                    key={index}
                    className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                    id={`nav-${category.toLowerCase()}`}
                    role="tabpanel"
                    aria-labelledby={`nav-${category.toLowerCase()}-tab`}
                  >
                    <div className="row">
                      {videos.map((url, videoIndex) => (
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={videoIndex}>
                          <div className="video_embed_wrapper">
                            <iframe
                              width="100%"
                              height="200"
                              src={url}
                              title={`YouTube video ${videoIndex + 1}`}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            ></iframe>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExploreArea;
